import { render, staticRenderFns } from "./FactoringContractTermsView.vue?vue&type=template&id=083e1649&lang=pug&"
import script from "./FactoringContractTermsView.vue?vue&type=script&lang=js&"
export * from "./FactoringContractTermsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports